import { PrismicRichText } from "@prismicio/react";
import { GatsbyImage } from "gatsby-plugin-image";
import React from "react";
import { PrismicReusableContentDataBodyIconAndText } from "../../types/graphql";
import { htmlSerializer } from "../../utils/htmlSerializer";
import { graphql } from "gatsby";

export const query = graphql`
  fragment IconAndTextModule on PrismicReusableContentDataBody {
    ... on PrismicReusableContentDataBodyIconAndText {
      slice_type
      primary {
        css_class
        heading {
          richText
          text
        }
        description {
          richText
          text
        }
        icon {
          gatsbyImageData
          url
          alt
        }
      }
    }
  }
`;

export type IIconAndTextProps = {
  slice: PrismicReusableContentDataBodyIconAndText;
};

const IconAndText = (props: IIconAndTextProps) => {
  const { slice } = props;
  const { primary } = slice;

  return (
    <div className={primary?.css_class || ""}>
      <GatsbyImage
        image={primary.icon?.gatsbyImageData}
        alt={primary.icon?.alt || "Xometry Resources"}
        loading="lazy"
      />
      <PrismicRichText
        field={primary.heading.richText}
        components={htmlSerializer}
      />
      <PrismicRichText
        field={primary.description.richText}
        components={htmlSerializer}
      />
    </div>
  );
};

export default IconAndText;
